import {
  Autocomplete,
  AutocompleteProps,
  Box,
  InputLabel,
  TextField,
} from "@mui/material";
import { ViewportAnchoredAutocompletePopper } from "../ViewportAnchoredAutocompletePopper";

interface CustomAutoCompleteProps
  extends AutocompleteProps<
    any,
    boolean | undefined,
    boolean | undefined,
    boolean | undefined
  > {
  label: string;
  inputValue: string;
}

export function LabeledAutoComplete(props: CustomAutoCompleteProps) {
  const { label, ...autoProps } = props;

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      alignItems={"flex-start"}
      width={"100%"}
    >
      {/* Sem rótulo (quem chama já titulou o campo por fora), o InputLabel
          vazio só somaria um espaço morto acima do input. */}
      {!!label && <InputLabel style={{ fontSize: "13px" }}>{label}</InputLabel>}
      <Autocomplete
        size="small"
        {...autoProps}
        PopperComponent={ViewportAnchoredAutocompletePopper}
        disablePortal={false}
        sx={[{ width: "100%" }, ...(Array.isArray(autoProps.sx) ? autoProps.sx : autoProps.sx != null ? [autoProps.sx] : [])]}
      />
    </Box>
  );
}
